import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { API_BASE_URL_SERVICE } from '../../../projects/kiene-core/src/lib/kiene-core.config';
import { MessageService } from '../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Injectable({ providedIn: 'root' })
export class FileDownloadService {
    constructor(
        private http: HttpClient,
        private messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    downloadCSV(url: string, params: HttpParams): Observable<number> {
        return this.download(url, 'text/csv', params, 'csv');
    }

    downloadExcel(url: string, params: HttpParams): Observable<number> {
        return this.download(url, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', params, 'excel');
    }

    downloadZip(url: string, params: HttpParams): Observable<number> {
        return this.download(url, 'application/zip', params);
    }

    download(url: string, mimeType: string, params: HttpParams, accept?: string): Observable<number> {
        const subject = new Subject<number>();

        if (!params) {
            params = new HttpParams();
        }

        let headers = new HttpHeaders();
        if (accept) {
            headers = headers.set('ACCEPT', accept);
        }

        this.http
            .get(this.apiBaseUrl + url, {
                params: params,
                responseType: 'blob',
                reportProgress: true,
                observe: 'events',
                headers: headers,
            })
            .subscribe({
                next: resp => {
                    if (resp.type === HttpEventType.DownloadProgress) {
                        const percentDone = Math.round((100 * resp.loaded) / resp.total);
                        console.log(percentDone);
                    }
                    if (resp.type === HttpEventType.Response) {
                        const response = resp as HttpResponse<Blob>;
                        const header = response.headers;
                        const blob = new Blob([response.body], { type: mimeType });
                        subject.next(blob.size);
                        if (blob.size <= 0) {
                            this.messageService.alertMessage('Keine Daten für Download gefunden!');
                            return;
                        }
                        const urlDownload = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = urlDownload;

                        const regex = /filename="(?<filename>.*)"/;
                        const erg = header?.get('Content-Disposition')?.match(regex);
                        if (erg && erg.groups['filename']) {
                            a.download = erg.groups['filename'];
                        } else {
                            a.download = 'Fehler.vetvet';
                        }

                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        setTimeout(() => {
                            window.URL.revokeObjectURL(urlDownload);
                        }, 100);
                    }
                },
                error: err => {
                    this.messageService.errorMessage(`${mimeType}  konnte nicht generiert werden!`, err);
                },
            });
        return subject.asObservable();
    }
}
